import { createContext } from "react";

export const journeyType = {
  normal: "NORMAL",
  newLine: "NEWLINE",
  addLine: "ADDLINE",
  upgrade: "UPGRADE",
};

export const CheckoutJourneyContext = createContext({
  journey: journeyType.newLine, //default value
  setJourney: () => {
    //code
  },
});
